module.exports = __webpack_public_path__ + "static/ross-house-ee1e5bb8e9a6d8d179da8602a5dd6873.jpg";